import {createUseStyles} from 'react-jss';
import MediaQueries from '../../style-helper/MediaQueries';
import setContrastColorBasedOnBackground from '../../style-helper/setContrastColorBasedOnBackground';
import Spacing from '../../style-helper/Spacing';
import Typography from '../../style-helper/Typography';
import loadArtemisFonts from '../ui/loadArtemisFonts';

export default createUseStyles({
  legalEntity: props => ({
    maxWidth: 960,
    margin: [0, 'auto'],
    borderTop: props.theme.footer.backgroundColour === '#f2f2f2' && '1px solid #ccc',
    paddingTop: props.isFooterWithLogo ? Spacing.triple : Spacing.double,
    paddingBottom: props.isFooterWithLogo && Spacing.triple,
    textAlign: 'left',
    fontSize: 13,
    letterSpacing: 0.3,
    color: '#666',
    lineHeight: 1.5,
    display: props.isFooterWithLogo && 'flex',
    justifyContent: props.isFooterWithLogo && 'space-between',
    alignItems: props.isFooterWithLogo && 'center',
  
    ...(props.isUsingArtemisStyles && props.theme.typography?.[Typography.extraSmall])
    && loadArtemisFonts(props.theme.typography[Typography.extraSmall]),
    
    [MediaQueries.phone]: {
      padding: props.isFooterWithLogo && Spacing.double,
    },
  }),
  corporateText: {
    marginBottom: 0,
    color: props => props.hasPoweredByLabel && '#ccc',
    fontSize: props => props.hasPoweredByLabel && 8,
  },
  
  staticTextContainer: {
    textAlign: 'center',
  
    [MediaQueries.tablet]: {
      margin: [0, 30],
    },
  
    [MediaQueries.phone]: {
      width: '100%',
    },
  },
  allRightsReservedText: {
    marginBottom: Spacing.half,
    fontSize: 10,
    color: props => (props.theme.footer.backgroundColour === '#f2f2f2'
      ? '#666' : setContrastColorBasedOnBackground(props.theme.footer.backgroundColour)),
  },
});
